module.exports = __webpack_public_path__ + "static/media/Oak-Creek-VHA_By-Laws.3ac95abf.pdf";